module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("The Pole")])])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"How beautiful she is,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("My breath was almost taken away by the incredible beauty of the former Miss Millicent Aubrey-Welles, once a debutante from Pennsylvania. She was slender and lovely. She was fairly complexioned and had delicately beautiful and sensitive features. She was exquisitely feminine. The slavers who had originally selected her to wear a Gorean collar had known their business. She was dressed, and adorned, in all the colorful, glittering, striking barbaric richness, in all the impressiveness and splendor, in all the festive display, fit for feasts and dances, of a red-savage female. Even the daughters of chieftains, such as Bloketu, the daughter of Watonka, might have envied her the sumptuousness and glory of her raiment. Her long shirtdress of soft-tanned tabuk hide was almost white. So, too, were her knee-length leggings and moccasins. These things, too, were painted with designs, and fringed. Her hair, red, radiant in the sun, had been braided in the fashion of the red savages. It was tied with golden string. Necklaces of shells and beads, and ornaments and trinkets, and pierced coins, of gold and silver, hung about her neck. On her wrists, visible within the capelike sleeves of the shirtdress, were silver bracelets. To look at her one might not have thought she was a slave. To be sure, her wrists were tied behind her back, and on her throat, leading to riders on each side of her, were two rawhide tethers. Detectable, but inconspicuous among all this finery, thrust up under her chin, above the tethers, was a beaded collar. It was Canka's. It was to him that she, in the final analysis, belonged.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"That is Cancega,\" whispered Cuwignaka to me.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A man was now riding slowly forward, alone, toward some trees a few hundred yards away. Lines of such trees, in the Barrens, and low, sloping geodesics, watersheds, tend to mark, often, the location of the tiny streams which occur in the country. Such streams, in this area, would be tributary to the Lower, or Southern, Kaiila. At this time of year, of course, they would be little more than trickles of water. Indeed, at this time of year, a man could wade the Southern Kaiila. Later in the year, in Kantasawi, many small streams would be dry altogether and even major rivers, like the Southern Kaiila itself, would seem little more than pools of water in a riverbed. The body of Cancega, clad in little more than a breechclout and a roach of feathers, was covered with medicine paint. In his hand he carried a long, feathered medicine wand.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"The five high coups have already been taken,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"What are they?\" I asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"The young men, more than a hundred of them, selected from the bands, sent ahead days ago, as soon as the Pte were sighted, have ridden for the tree.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I do not understand,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It is a race,\" said Cuwignaka. \"They are lined up. The first five men who strike the tree, with their hand, or with a canhpi, a lance or coup stick, obtain high coups.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Did Canka or Hci participate in this race?\" I asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No,\" said Cuwignaka. \"Both of them, in former years, have obtained such a coup.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"The group is advancing,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"We shall accompany them,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("We then walked along with the group, some mounted and some, like ourselves, on foot, who, in effect, were following Cancega.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Cancega seems to be a very important fellow,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"He is more important than you understand,\" said Cuwignaka. \"At this time, during the festivals, he is in charge of the whole camp. We listen to him. We do what he says.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"He is, then,\" I said, \"at this time, in effect, the chief of all the Kaiila.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I do not think I would put it just that way,\" said Cuwignaka, somewhat defensively. \"The civil chiefs, in deferring to him, are not really relinquishing their power.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I see the distinction,\" I said. \"Do all the Kaiila ever have but one chief?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Sometimes a war chief is elected,\" said Cuwignaka. \"In a sense, then, he is the high chief.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"But a war chief cannot be a civil chief,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No,\" said Cuwignaka. \"It is better, we think, to keep those things apart.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"That is interesting,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"One may, of course, at different times, be a war chief and a civil chief,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I understand,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Sometimes a man is good at both,\" said Cuwignaka, \"but they are still different things.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I understand,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"And, generally, I think,\" said Cuwignaka, \"that it would be only a very unusual man who would be good at both.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Perhaps,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"They are very different sorts of things,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"That seems to me right,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("In moments we, with the others, were splashing across a narrow, shallow stream. I could see pebbles in the bottom of this stream. The Southern, or Lower, Kaiila, like the other larger rivers in the Barrens, however, bearing witness to the accumulation of silts, would be brown and muddy.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("On the other side of the stream Cancega, and most of his fellows, dismounted, their kaiila being held to the side.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cancega, then, began a slow, shuffling dance. Two others, near him, also with roaches of feathers, shaking rattles, joined him. The focal point of this dance, which wove back and forth, in a fanlike motion, before it, was a high, white-barked tree. Cancega repeated, over and over, carrying the medicine wand, and dancing, \"It is the tree.\" The other two fellows, who had joined him, with the rattles, would add a refrain, \"It is tall and straight.\" This refrain, too, was sometimes echoed by those about us.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Winyela, her hands bound behind her, and her neck in the tethers, in her finery, watched.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I could see the marks of various weapons in the bark of the tree where, perhaps two or three days ago, the young men had charged to it, to be the first to reach it, in their race for coups.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It is the tree!\" suddenly cried Cancega, rushing to the tree and striking it with the medicine wand.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It is tall and straight!\" shouted the two seconds, in the dance, and most of the others, as well, including my friend, Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Two men rushed to Winyela and untied her hands. She was pushed forward, the tethers still on her neck, but now rather behind her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A long-handled, single-bladed ax was pressed into her hands. It was a trade ax. Its back was blunted, for the driving of pegs, stakes and wedges. It was heavy for her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You should not be here,\" said a man to Cuwignaka. \"This is no place for free women.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I am a man,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The man shrugged.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I looked about. To be sure, there were no women present, with the exception of the lovely Winyela.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She began, under the direction of Cancega, and others, to strike at the lower portions of the tree.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I wondered why there were no free women present. Could it be that something was to occur which was regarded as not being suitable, perhaps, for the sensibilities of free women?")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Winyela continued to chop at the tree.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It was some twenty-five to thirty feet in height, but it was not, really, a large tree. Its trunk was slim and polelike, and surely only some eight to ten inches in width. A man, working with such a tool, would have felled it in a matter of moments. Winyela, of course, was neither a man nor a woodsman. She was only a lovely slave. Her hands were widely spaced on the ax handle, and her blows were short. Cancega and the others, interestingly, in spite of the fact that she was a slave, were patient with her. To be sure, she had enough sense not to beg to rest. The necklaces and ornaments she wore rustled and shimmered, making tiny sounds, as she labored. I supposed it was the first time in her life she had had such an implement in her hands. They are seldom used by debutantes from Pennsylvania nor, of course, by Gorean slave girls.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I saw Canka ride up, on his kaiila. He had come, apparently, from the camp. She looked at him, the tethers on her neck. He indicated that she should continue to work.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("In a moment there was a cracking noise, and then, after a few more blows, a splintering, rending sound as the tree tipped, and then, its branches striking the earth, fell. Five last blows were struck, cutting the last fibers and wood, and the trunk, freed, laid level, a yard above the ground, held in place by branches and foliage.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The men grunted with approval. The ax was removed from Winyela's hands and she was dragged back and knelt, her knees closely together, on the ground. The two men who held her tethers now stood beside her, the slack in the tethers, looped, now taken up, the rawhide loops in their fists.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"What occurs now?\" I asked Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Watch,\" said he to me.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Several of the men, now, under the direction of Cancega, began to remove the branches and bark from the felled tree. Two forks were left, one about eighteen feet high and the other about twenty-three feet high. This was to allow for the pole later being set in the earth, within the enclosure of the dance, set among its supporting stakes, to a depth of some seven or eight feet. These forks would then be, respectively, about ten and fifteen feet high.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The slim trunk of the tree, with its forks, stripped of its bark, was now long, smooth and white.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It was set in two stout tripods of branches, about a yard above the ground.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Paint was brought forth, in a small clay vessel. The girl, too, was again brought forward.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It was she, herself, with the paint, the slave, who must proclaim that the pole was Kaiila. In this type of application of paint, on wood, over a large surface, or bands of a large surface, a brush of chopped, twisted grass is used. The paint itself was red. This red was probably obtained from powdered earths or clays. It may also, of course, have been obtained from crushed rock, containing oxides of iron. Some reds, too, may be obtained from boiled roots.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Winyela, in her finery, the beautiful, delicate, red-haired, white slave girl, under the direction of Cancega, medicine chief of the summer camp of all the Kaiila, carefully, obediently, frightened, applied the red paint. \"It is Kaiila,\" chanted many of the men about, as she did this. Thrice did Winyela, with the brush, as the pole was turned in the tripods, scarletly band the rotated surface. \"It is Kaiila,\" chanted the men. She was then drawn back, the paint and brush removed from her, and again knelt, her knees closely together, the two tethers on her throat.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The three scarlet bands of paint were bright on the white pole. Scarlet bands, in number from one to five, are commonly used by Kaiila warriors to mark their weapons, in particular their lances and arrows. To this mark, or marks, then, will be added the personal design, or pattern, of the individual warrior. An arrow then, say, may be identified not only as Kaiila, but, within the tribe, or band, as the arrow of a particular warrior.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The Kaiila, incidentally, in the Barrens, are generally known as the \"Cutthroat tribe.\" The bands, then, generally by outsiders, and usually even among the Kaiila themselves, are supposed to have this sort of significance. I have met Kaiila, however, who have denied this entire line of interpretation. They call my attention to the fact that the Kaiila themselves seldom, among themselves, think of themselves as the \"Cutthroat tribe.\" They think of themselves as being the Kaiila, or the people of the Kaiila. Similarly they point out that a symbolic representation of a cut throat should surely be a single slash, not one or more encircling bands. The true origin, then, of the encircling bands, I suppose, is lost in history. The bands, incidentally, are usually three in number. This suggests to me that they might originally have been thought to be phallic in significance. The number three, as is well known, is often thought to be a very special number. This probably has to do, of course, with the triune nature of the male genitals.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The paint was bright on the pole.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The three bands, each about four or five inches in width, and separated also by such distances, were painted in such a way that the bottom ring, or band, was about seven and a half to eight and a half feet from the base of the pole. Thus, when the pole was set in the ground, amidst its supporting stakes, these circles would be at the visible base, or root, of the pole. Too, they would be beneath the belt of an encircling dancer.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It is Kaiila!\" shouted the men.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The neck tethers were then removed from Winyela. I gathered that her part in the ceremony was now concluded.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Suddenly the girl screamed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I tensed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Do not interfere,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The hands of men, then, were at the necklaces about her throat, the ornaments. Her moccasins and leggings were removed. The golden strings were untied, and taken, which had bound her hair. Her hair was rapidly and deftly unbraided. The silver bracelets were slipped from her wrists. The soft-tanned shirtdress, with its designs, and beading and fringe, was then thrust over her head and pulled away. She now knelt absolutely naked, save for Canka's collar, among the men. Her knees were clenched closely together. Her hair, now loose, radiant in the sun, was spread and smoothed down her back. She was very white. She almost shone in the sun. Not only was she quite fairly complexioned but, prior to her being adorned in her finery, now removed from her, she had been washed, and clipped, and groomed and scrubbed, apparently, as thoroughly and carefully as a prize kaiila.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"She is quite beautiful,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The girl whimpered as the two rawhide tethers were now, again, tied on her throat, below Canka's collar.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"What is to be done with her now?\" I asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Observe,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Oh,\" cried the girl. One of the men, behind her, had thrown dust upon her. \"Oh!\" she sobbed, as two men, rather in front of her, one on each side, tossed, each, a double handful of dust upon her. She closed her eyes, blinking against the grit of the dust. Then she opened her eyes, and shrank back, for Cancega, with a shallow, rounded box, was crouching before her. The box contained some sort of black paste, or grease. She shuddered as Cancega, taking the material on his fingertips, applied it to her cheeks. He made three dark lines, about a finger's width each, on each cheek. These were signs, I supposed, for the Kaiila. Then he rubbed the material elsewhere, in smudges, upon her body, on her arms, and back, and breasts and belly, and on the tops of her thighs, on her calves, and, then, thrusting his hand between them, on the interior of her thighs.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The girl regarded him, frightened, as he, intent, did this work.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He then stood up.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She knelt at his feet, looking up at him, frightened, her knees now again pressed closely together.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Two men, with kaiila quirts, now stood behind the girl. She was not aware of their presence.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I then realized what the men, doubtless, had in mind.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I smiled.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Oh!\" cried the girl, frightened, dismayed, as Cancega suddenly, with his foot, forced her knees widely apart. She did not dare close them. She now, for the first time in the afternoon, knelt as a slave.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Then, suddenly, the two men with the kaiila quirts struck her across the back and, before she could do more than cry out, she was, too, pulled to her feet and forward, on the two tethers.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She then stood, held by the tethers, wildly, before the pole.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cancega pointed to the pole.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She looked at him, bewildered. Then the quirts, again, struck her, and she cried out in pain.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cancega again pointed to the pole.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Winyela then put her head down and took the pole in her small hands, and kissed it, humbly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes,\" said Cancega, encouraging her. \"Yes.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Again Winyela kissed the pole.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes,\" said Cancega.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Winyela then heard the rattles behind her, giving her her rhythm. These rattles were then joined by the fifing of whistles, shrill and high, formed from the wing bones of the taloned Herlit. A small drum, too, then began to sound. Its more accented beats, approached subtly but predictably, instructed the helpless, lovely dancer as to the placement and timing of the more dramatic of her demonstrations and motions.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It is the Kaiila,\" chanted the men.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Winyela danced. There was dust upon her hair and on her body. On her cheeks were the three bars of grease that marked her as the property of the Kaiila. Grease, too, had been smeared liberally upon her body. No longer was she a shining beauty. She was now only a filthy slave, an ignoble animal, something of no account, something worthless, obviously, but nonetheless permitted, in the kindness of the Kaiila, a woman of another people, to attempt to please the pole.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I smiled.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Was this not suitable? Was this not appropriate for her, a slave?")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Winyela, kissing the pole, and caressing it, and moving about it, and rubbing her body against it, under the directions of Cancega, and guided sometimes by the tethers on her neck, continued to dance.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I whistled softly to myself.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Ah,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It is the Kaiila!\" chanted the men.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I think the pole will be pleased,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I think a rock would be pleased,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I agree,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Winyela, by the neck tethers, was pulled against the pole. She seized it, and writhed against it, and licked at it.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It is the Kaiila!\" chanted the men.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It is the Kaiila!\" shouted Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A transformation seemed suddenly to come over Winyela. This was evinced in her dance.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"She is aroused,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She began, then, helplessly, to dance her servitude, her submission, her slavery. The dance, then, came helplessly from the depths of her. The tethers pulled her back from the pole and she reached forth for it. She struggled to reach it, writhing. Bit by bit she was permitted to near it, and then she embraced it. She climbed, then, upon the pole. There her dance, on her knees, her belly and back, squirming and clutching, continued.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I looked to Canka. He was a few yards away, astride his kaiila. He rode bareback. This is common in short rides about the village, or in going out to check kaiila. The prestige of the saddle, and its dressiness, is not required in local errands or short jaunts. Similarly, in such trips its inconvenience may be dispensed with. He watched Winyela dance. His dark eyes shone. He knew he was her master.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Winyela now knelt on the pole and bent backwards, until her hair fell about the wood, and then she slipped her legs down about the pole and lay back on it, her hands holding to the pole behind her head. She reared helplessly on the pole, and writhed upon it, almost as though she might have been chained to it, and then, she turned about and lay on the pole, on her stomach, her thighs gripping it, her hands pushing her body up, and away from the pole, and then, suddenly, moving down about the trunk, bringing her head and shoulders down. Her red hair hung about the smooth, white wood. Her lips, again and again, pressed down upon it, in helpless kisses.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"She is quite good, the slave,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"She has not been trained to do this, has she?\" asked Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Not to my knowledge,\" I said. It seemed to me rather unlikely that debutantes from high society would be trained to perform the supplication and passion dances of slave girls.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It is instinctual in a woman,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I think so,\" I said. It seemed to me not unlikely, for many reasons, having to do with sexual selection, in particular, that such behaviors were, at least in broad outlines, genetically coded. Behaviors can be selected for, of course, and tendencies to behaviors, as well as such things as the color of hair and eyes. This is evident from the data of ethology. A woman's acquisition of the skills of erotic dance, incidentally, like those of a child's linguistic skills, follows an unusually sharp learning curve. This suggests that the rudiments of such dance, or the readiness for it, like the capacity, at least, for the rapid and efficient acquisition of language, is genetically coded. Sex, and human nature, may not be irrelevant to biology.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Superb,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Winyela, helplessly, piteously, danced her obeisance to the great pole, and, in this, to her masters, and to men.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Look,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes,\" I said. \"Yes!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I well understood, now, why free women could not be permitted to see such a dance. It was the dance of a slave. How horrified, how scandalized, they would have been. Better that they not even know such things could exist. Such dances, that such things could be, are doubtless best kept as the secrets of masters and slaves. Too, how furious, how outraged, they would be, to see how beautiful, how exciting and desirable another woman could be, a thousand times more beautiful, exciting and desirable than themselves, and one who was naught but a slave. But then how could any free woman compete with a slave, one who is truly mastered and owned?")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I watched Winyela dance.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It was easy to see how free women could be almost insanely jealous of slaves, and how they could hate them so, so inordinately and deeply. Too, it was little wonder that slaves, helpless in their collars, so feared and dreaded free women.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"The slave dances well,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("In her dance, of course, Winyela was understood to be dancing not only her personal slavery, which she surely was, but, from the point of view of the Kaiila, in the symbolism of the dance, in the medicine of the dance, that the women of enemies were fit to be no more than the slaves of the Kaiila. I did not doubt but what the Fleer and the Yellow Knives, and other peoples, too, might have similar ceremonies, in which, in one way or another, a similar profession might take place, there being danced or enacted also by a woman of another group, perhaps even, in those cases, by a maiden of the Kaiila. I, myself, saw the symbolism of the dance, and, I think, so, too, did Winyela, in a pattern far deeper than that of an ethnocentric idiosyncrasy. I saw the symbolism as being in accord with what is certainly one of the deepest and most pervasive themes of organic nature, that of dominance and submission. In the dance, as I chose to understand it, Winyela danced the glory of life and the natural order; in it she danced her submission to the might of men and the fulfillment of her own femaleness; in it she danced her desire to be owned, to feel passion, to give of herself, unstintingly, to surrender herself, rejoicing, to service and love.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It is the Kaiila!\" shouted the men.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It is the Kaiila!\" shouted Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Winyela was dragged back, toward the bottom of the pole, on its tripods. There she was knelt down. The two men holding her neck tethers slipped the rawhide, between their fist and the girl's neck, under their feet, the man on her left under his right foot, and the man on her right under his left foot. But already Winyela, of her own accord, breathing deeply from the exertions of her dance, and trembling, had put her head to the dirt, humbly, before the pole. Then the tension on the two tethers was increased, the rawhide on her neck being drawn tight under the feet of her keepers. I do not think Winyela desired to raise her head. But now, of course, she could not have done so had she wished. It was held in place. I think this is the way she would have wanted it. This is what she would have chosen, to be owned, to serve, to be deprived of choice.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The men about slapped their thighs and grunted their approval. The music stopped. The tethers were removed from Winyela's neck. She then, tentatively, lifted her head. It seemed now she was forgotten. Her garments and jewelry, rolled in a bundle, were tied in what would be the lower fork of the pole. Two other objects, on long thongs, which were wrapped about the higher fork, were placed in the higher fork. Later, when the pole was set in the enclosure of the dance, the thongs would be unwrapped and the two objects would hang beside the pole. Both were of leather. One was an image of a kailiauk. The other was an image of a man. The image of the man had an exaggerated phallus, thrust forth and nearly as long as an arm, of a sort common in primitive art. I was reminded by these things of the medicine of the pole, and of the great forthcoming dance, projected to take place about it. The medicine of the pole and dance had intimately to do, obviously, with such things as hunting, fertility and manhood. To the red savage the medicine world is very real.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You may get up,\" said Cuwignaka to Winyela. She was looking about herself, bewildered, apparently forgotten. She rose up and went to the side of Canka, astride his kaiila, her master. Men were lowering the medicine pole to the ground and breaking apart the tripods. Ropes had been put on the pole. Then, preceded by Cancega, with his medicine wand, uttering formulas, followed by his two seconds, with their rattles, the pole, pulled on its ropes, being drawn by several kaiila, was dragged toward the camp.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You were very beautiful, Winyela,\" said Canka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Thank you, Master,\" she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He put down his hand and drew her up, before him, both her legs to the left side, to the back of the Kaiila. He then held her in place, before him. He wore only his breechclout, moccasins and knife.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I am so dirty,\" she said. \"Surely you will not want me to touch your body.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("But he held her to him, possessively. One arm was about her shoulders, the other beneath her thighs. She looked small in his arms, on the kaiila.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I am so ashamed,\" she said, \"how I must have looked, how I acted.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I remembered that she was from Earth, with its foolish, irrational negativistic conditionings, largely a heritage from the teachings of celibate lunatics. How pernicious can be the infected, poisonous heirlooms of madmen.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"In your dance,\" said Canka, \"you were not ashamed.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No,\" she said. \"It was almost as though I were another. I was sensuous, brazen, bold and free.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Free?\" asked Canka, smiling.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Surely Master knows that of all women it is only a total slave who can be truly free.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Canka smiled. In one sense, of course, the slave has no freedom whatsoever. She has no rights, and is totally and absolutely owned. In another sense, of course, she is the most free of women.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I am not truly ashamed,\" said the girl.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I know,\" said Canka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Rather, I am shamelessly proud and happy,\" she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Good,\" said Canka. \"That is how it should be.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I am only a slave,\" she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"That is true,\" said Canka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It is your collar which is on my neck, Master,\" she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes,\" said Canka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I am your slave,\" she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes,\" said Canka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I love you, Master,\" she said. \"Do you care for me, perhaps, just a little?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Perhaps,\" said Canka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She nestled back, in his arms.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"What are you going to do with me now, Master?\" she asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I am going to take you to my lodge,\" said Canka. \"There I will use you, many times.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Ho, Itancanka,\" she said. \"Yes, Master.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Canka then moved his heels back into the flanks of the kaiila and, guiding it with his knees, turned it back towards the village.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7edbf078","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section4.vue
// module id = 75
// module chunks = 0